import Socket from '../../classes/WebSocket'
import SessionManager from '../Session.manager';
import VueSignals from '../../scripts/VueSignals';


export default class UserNotification{
    constructor(){}
    /**
     *  Notification  UserJoined channel by Invitation acception
     */
    static UserJoined(channel_id, loggedInUser, user_ids){                        
        let post = {
            "event": VueSignals.SOCKET_USER_JOIN_CHANNEL,
            "channel_id": channel_id,
            "user": loggedInUser,
            "broadcast": {
                "user_ids": user_ids
            },
        }
        Socket.push(post)
    }


    static UserLeft(channel_id,user_ids){      
        let post = {
            "event": VueSignals.SOCKET_USER_LEFT_CHANNEL,
            "channel_id": channel_id,
            "broadcast": {
                "user_ids": user_ids
            },
        }
        Socket.push(post)
    }


    static UserCreated(userChannels, user_doc){        
        for(let i=0;i<userChannels.length;i++){
            let post = {
                "event": VueSignals.SOCKET_USER_CREATED,
                "user_doc": user_doc,
                "broadcast": {
                    "user_ids": userChannels[i].user_ids
                },
            }
            Socket.push(post)
        }        
    }
}